<template>
  <AppView
    padd-bottom
  >

    <template v-slot:top-app-view>
      <transition name="fade" mode="out-in" appear>
        <TopNav
          type="back"
          :show-back-button="isSuperAdmin"
          :prev-route="{ name: (isSuperAdmin ? 'viewCompany' : 'myLicense'), params: { id: $route.params.id } }"
          :title="company.company || 'fetching company...'"
          :title-class="[
            { 'tw-ml-8': isSuperAdmin },
            { 'ml-body': !isSuperAdmin },
            { 'opacity-78 font-title tw-text-xl tw-tracking-wider tw-leading-6': !loadingCompany },
            { 'opacity-31 tw-italic tw-lowercase': loadingCompany },
          ]"
        >
          <template v-slot:title-left v-if="!loadingCompany">
            <UserPhoto
              :photo="company.logo"
              :user-name="{
                name: company.company,
              }"
              logo
              photo-size="tw-h-12 tw-w-12"
              :class="[
                'tw-mr-6 tw-my-1 tw-rounded-10--force --force-children tw-bg-app-white-87',
                { 'tw-shadow-app-sm': !(company.logo || '').length }
              ]"
            />
          </template>
        </TopNav>
      </transition>
    </template>

    <transition name="fade" mode="out-in" appear>

      <div v-if="errorCompany" class="tw-mt-12" key="errmsg">
        <p class="tw-py-12 tw-text-base tw-text-center" v-html="errorCompany"></p>
      </div>

      <div v-else-if="loadingCompany" class="tw-mt-12" key="lodng">
        <p class="tw-py-12 tw-text-base tw-text-center">Loading...</p>
      </div>

      <div v-else key="bdy">

        <transition name="fade" mode="out-in" appear>

          <div class="app-view-grid px-body">
            <div class="app-view-grid__col-74">

              <h3 class="font-title tw-text-xl tw-tracking-wider auth-card tw-mx-auto tw-block tw-mb-5">
                New Program
              </h3>

              <CreateProgram
                :company="company"
                @created-success="programCreated"
              />

            </div>
          </div>

        </transition>

      </div>

    </transition>

  </AppView>
</template>

<script>
import UserPhoto from '@/components/UserPhoto.vue';
import CreateProgram from '@/views/Companies/Company/_partials/CreateProgram.vue';

import companyMixin from '@/mixins/company';

export default {
  name: 'CreateCompanyProgram',
  components: {
    UserPhoto,
    CreateProgram,
  },
  mixins: [companyMixin],
  data() {
    return {
      loadingPrograms: true,
      errorPrograms: undefined,
      companyPrograms: [],
      programTypes: [],
      selectedProgram: {},
    };
  },
  props: ['id'],
  computed: {
    programStatuses() {
      return this.$store.state.CompanyPrograms.ProgramContext.programStatuses;
    },
  },
  methods: {
    async getCompanyPrograms() {
      this.loadingPrograms = true;
      this.errorPrograms = undefined;

      await this.$nextTick();

      const companyPrograms = await this.$store.dispatch('getCompanyPrograms', [this.id, true]);

      if (!companyPrograms) {
        this.errorPrograms = 'Error getting company programs';
      } else {
        this.companyPrograms = companyPrograms;
      }

      await this.$nextTick();

      this.loadingPrograms = false;
    },
    async getProgramTypes() {
      const programTypes = await this.$store.dispatch('getProgramTypes', []);

      if (programTypes) {
        this.programTypes = programTypes;
      } else {
        console.error('Error getting program types. \n getProgramTypes::', programTypes);
      }
    },
    async programCreated() {
      this.$router.push({
        name: 'viewCompany',
        params: {
          id: this.company.id,
        },
      });
    },
  },
  async created() {
    // get company
    await this.getCompany();

    await this.$nextTick();

    // assert user company permissions
    if (!this.hasPermission) {
      this.$router.push({
        name: 'app',
      });

      return false;
    }

    if (this.isSuperAdmin) {
      await this.getProgramTypes();
      await this.getCompanyPrograms();
    } else {
      this.selectedProgram = this.$store.state.ProgramContext.activeProgram;
    }

    await this.$nextTick();
    await this.$nextTick();

    this.loadingCompany = false;
    return true;
  },
};
</script>

<style>
.img-width-100 {
  width: 100px;
  height: 100px;
}
</style>
